/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useState, useEffect } from 'react'
import clsx from 'clsx'
import { connect } from 'react-redux'
import {
  makeStyles,
  createStyles,
  Theme,
  Typography,
  Tooltip,
  withStyles,
} from '@material-ui/core'
import Button from '../Button/Button'
import QuantitySelector from '../Shop/QuantitySelector'
import { Cart, Products, shortProduct } from '../../typings/base'
import { checkStockQuantity } from '../../utils/utils'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import CMSText, { prismicText } from '../Global/CMSText'
import Price from '../Shop/Price'
import AvailabilityChecker from '../Shop/AvailabilityChecker'
import { getProductVariantAvailability } from '../../redux/actions/products'
import BackInStockAlert from '../BackInStockAlert/BackInStockAlert'
import { useRouter } from 'next/router'
import { isSubscription } from '../../utils/constants'
import ProductSkiForm from '../Products/ProductSkiForm'

type Tprops = {
  open?: boolean
  handleClose?: () => void
  products: Products
  text: any
  stock: any
  t: any
  onQuantityChange?: (
    code: string,
    name: string,
    quantity: number,
    tryout: boolean
  ) => void
  cart: Cart
  settings: any
  getProductVariantAvailability?: (sku: string) => Promise<any>
  endLeasingDate?: Date
  parameters: any
  stores: any
  isSki: boolean
  skiText: any
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
    sizes: {
      display: 'flex',
      justifyContent: 'flex-start',
      marginTop: theme.spacing(1),
    },
    sizes__label: {
      paddingRight: theme.spacing(1),
    },
    sizes__list: {
      padding: theme.spacing(0.25, 0.25, 0.25, 0),
      borderRadius: theme.spacing(1),
      marginBottom: theme.spacing(1),
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
    },
    addButton: {
      display: 'flex',
      justifyContent: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-between',
        marginTop: theme.spacing(1),
      },
    },
    button: {
      display: 'inline-flex',
      justifyContent: 'flex-end',
      width: '100%',
    },
    sizeButton: {
      height: theme.spacing(4),
      padding: theme.spacing(1, 2),
      margin: theme.spacing(0.5, 0.5, 0.5, 0),
      minWidth: 45,
      backgroundColor: theme.extraColors.greyLight,
      '&:hover': {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
      },
      '&.sold-out': {
        opacity: 0.5,
        color: theme.palette.error.main,
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0.5, 1),
        margin: theme.spacing(0.25),
      },
    },
    withoutStock: {
      opacity: 0.5,
      color: theme.palette.error.main,
    },
    selected: {
      height: theme.spacing(4),
      padding: theme.spacing(1, 2),
      margin: theme.spacing(0.5, 0.5, 0.5, 0),
      minWidth: 45,
      color: theme.palette.common.white,
      backgroundColor: theme.palette.common.black,
      '&:hover': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.common.black,
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0.5, 1),
        margin: theme.spacing(0.25),
      },
    },
    quantSelector: {
      marginRight: theme.spacing(2),
    },
    quantityChip: {
      position: 'absolute',
      top: -5,
      right: -5,
      minWidth: 20,
      height: 20,
      lineHeight: '20px',
      borderRadius: 20,
      padding: '0px 6px',
      fontSize: 13,
      border: `1px solid ${theme.palette.common.white}`,
      color: theme.palette.common.white,
      backgroundColor: theme.palette.secondary.main,
    },
    quantityChipSelected: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.common.white,
    },
    tryOut: {
      marginBottom: theme.spacing(1.5),
    },
    tryOutButton: {
      marginTop: theme.spacing(1.5),
    },
    fullWidth: {
      width: '100%',
    },
    availabilityChecker: {},
  })
)

const MainTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    fontSize: 12,
    textAlign: 'center',
    padding: theme.spacing(1),
    width: '100%',
  },

  arrow: {
    color: theme.palette.secondary.main,
  },
}))(Tooltip)

const mapStateToProps = (state) => ({
  parameters: state.parameters,
  stores: state.stores,
})

const mapDispatchToProps = {
  getProductVariantAvailability: getProductVariantAvailability,
}

const Size = ({
  products,
  onQuantityChange,
  cart,
  text,
  t,
  stock,
  settings,
  getProductVariantAvailability,
  parameters,
  stores,
  isSki,
  skiText,
}: Tprops) => {
  const isAvailabilityChecker = text?.data?.availability_checker
  const classes = useStyles()
  const { asPath } = useRouter()
  const [code, setCode] = useState('')
  const [name, setName] = useState('')
  const [quantity, setQuantity] = useState(1)
  const [hasInStock, setHasInStock] = useState(null)
  const [isTryOutAble, setIsTryOutAble] = useState(false)
  const { trackEvent } = useMatomo()
  const [hasTryOut, setHasTryOut] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)
  const [showTooltipRent, setShowTooltipRent] = useState(false)
  const [tryOnPrice, setTryOnPrice] = useState(0)
  const [maxItemsInCart, setMaxItemsInCart] = useState(null)
  const [availybilityChecker, setAvailybilityChecker] = useState(false)
  const [unvailabilities, setUnvailabilities] = useState([])
  const [focusedProduct, setFocusedProduct] = useState<shortProduct[]>([])
  const variants = []
  const baseUrl =
    typeof window !== 'undefined' && window.location.origin
      ? window.location.origin
      : ''

  const warehouseId = stores?.selectedStore?.warehouseId
    ? stores?.selectedStore?.warehouseId
    : process.env.CUSTOM_WAREHOUSE
    ? process.env.CUSTOM_WAREHOUSE
    : null

  const currentFullUrl = baseUrl + asPath

  const variantsMap = new Map()

  Object.keys(products.variants).map((variantIndex) => {
    const variant = products.variants[variantIndex]

    variants.push(variant)
    variantsMap.set(variant.code, variant)
  })

  const selectedVariant = variantsMap.get(code)

  useEffect(() => {
    if (variants.length > 0) {
      setHasTryOut(variants[0].tryingOnRequired)
      setTryOnPrice(variants[0].tryingOnPrice)
    }
  }, [variants])

  useEffect(() => {
    // reset quantity when cart change (ie if a product is delete, it update the quantity)
    // TODO Check how many product are rented and other tryout
    let globalQuantRented = 0
    let globalQuantTryOut = 0
    cart?.item?.items.length > 0 &&
      cart?.item?.items?.map((item) => {
        if (!item?.withTryingOn) {
          globalQuantRented += item.quantity
        } else {
          globalQuantTryOut += item.quantity
        }
      })
    if (globalQuantRented > globalQuantTryOut) {
      setIsTryOutAble(true)
    } else setIsTryOutAble(false)
    setQuantity(
      cart &&
        cart.item &&
        cart.item.items.length > 0 &&
        typeof cart.item.items.find(
          (el) => el.product.variants[0].code === code
        ) !== 'undefined'
        ? cart.item.items.find((el) => el.product.variants[0].code === code)
            .quantity
        : 0
    )
  }, [cart.item])

  const handleChange = (code, name, tryingOnRequired, tryingOnPrice) => {
    const selectedProduct = products?.variants[code]
    const inStock = checkStockQuantity(stock, selectedProduct)
    setFocusedProduct([
      {
        sku: selectedProduct.sku,
        quantity: inStock,
      },
    ])
    setCode(code)
    setName(name)
    setHasTryOut(tryingOnRequired)
    setTryOnPrice(tryingOnPrice)
    setQuantity(
      cart &&
        cart.item &&
        cart.item.items.length > 0 &&
        typeof cart.item.items.find(
          (el) => el.product.variants[0].code === code
        ) !== 'undefined'
        ? cart.item.items.find((el) => el.product.variants[0].code === code)
            .quantity
        : 0
    )
    setMaxItemsInCart(selectedProduct?.maxStock)
    setHasInStock(inStock)
    trackEvent({
      category: 'Products',
      action: `Size selected`,
      name: `${name}`,
    })
    if (isAvailabilityChecker) {
      if (inStock === 0) {
        setAvailybilityChecker(true)
        setHasInStock(inStock)
        const checkProductVariantStock = async () => {
          const response = await getProductVariantAvailability(
            products?.variants[code].sku
          )
          if (response.type === 'GET_STOCK_AVAILABILITY_SUCCESS') {
            setUnvailabilities(response.availabilities)
          }
        }
        checkProductVariantStock()
      } else {
        setAvailybilityChecker(false)
        setHasInStock(inStock)
      }
    }
  }

  const changeQuantity = (quantity: number) => {
    const inStock = checkStockQuantity(stock, products?.variants[code])
    if (quantity <= inStock) {
      setQuantity(quantity)
      trackEvent({
        category: 'Products',
        action: `Quantity changed`,
        name: `product ${products.name}`,
        value: quantity,
      })
    }
  }

  //For now the stock alert is made only for sub stores
  const showStockAlert = isSubscription && hasInStock === 0

  return (
    <>
      <div className={classes.root}>
        <div className={`sizes ${classes.sizes}`}>
          <Typography
            component={'div'}
            className={`size__label ${classes.sizes__label}`}
          >
            <strong>
              <CMSText
                asText
                data={settings?.data?.sizes}
                defaultText={t('texts:general:sizes')}
              />
            </strong>
          </Typography>
          <Typography component={'div'} className="sizes__stock">
            {code !== '' && hasInStock === 0 && settings?.data?.back_soon && (
              <CMSText
                asText
                data={settings?.data?.back_soon}
                defaultText={t('texts:general:stock_texts:back_soon')}
              />
            )}
            {code !== '' &&
              hasInStock > 0 &&
              hasInStock < 6 &&
              settings?.data?.few_products_left && (
                <CMSText
                  asText
                  data={settings?.data?.few_products_left}
                  defaultText={t('texts:general:stock_texts:few_products_left')}
                />
              )}
            {code !== '' && hasInStock > 5 && settings?.data?.in_stock && (
              <CMSText
                asText
                data={settings?.data?.in_stock}
                defaultText={t('texts:general:stock_texts:in_stock')}
              />
            )}
          </Typography>
        </div>
        <div className={`sizes__list ${classes.sizes__list}`}>
          {variants &&
            variants?.map((variant, index) => {
              return (
                <Button
                  key={index}
                  size="small"
                  className={
                    variant.code === code
                      ? `sizes__btn selected ${classes.selected}`
                      : `sizes__btn ${classes.sizeButton}`
                  }
                  onClick={() =>
                    handleChange(
                      variant.code,
                      variant.size,
                      variant.tryingOnRequired,
                      variant.tryingOnPrice
                    )
                  }
                  data-testid={`btn-size-${index}`}
                >
                  {variant.size}
                  {cart &&
                    cart.item &&
                    cart.item.items.length > 0 &&
                    typeof cart.item.items.find(
                      (el) => el.product.variants[0].code === variant.code
                    ) !== 'undefined' &&
                    cart.item.items.find(
                      (el) => el.product.variants[0].code === variant.code
                    )?.quantity && (
                      <div
                        className={
                          variant.code === code
                            ? `sizes__chip ${classes.quantityChip}`
                            : `sizes__chip selected ${classes.quantityChip} ${classes.quantityChipSelected}`
                        }
                      >
                        {cart &&
                          cart.item?.items.length > 0 &&
                          typeof cart.item.items.find(
                            (el) => el.product.variants[0].code === variant.code
                          ) !== 'undefined' &&
                          cart.item.items.find(
                            (el) => el.product.variants[0].code === variant.code
                          )?.quantity}
                      </div>
                    )}
                </Button>
              )
            })}
        </div>
        {availybilityChecker && (
          <div className={classes.availabilityChecker}>
            <AvailabilityChecker
              t={t}
              texts={text?.data}
              cart={cart}
              unvailabilities={unvailabilities}
              endLeasingDate={parameters.items.maximumLeasingDays}
            />
          </div>
        )}
        {showStockAlert && (
          <BackInStockAlert
            singleProductPrismicData={text}
            products={focusedProduct}
            url={currentFullUrl}
            warehouseId={warehouseId}
          />
        )}
        {!isSki ? (
          <>
            {!hasTryOut &&
              hasInStock !== 0 &&
              (settings?.data?.has_quantity_selector ? (
                <div className={clsx('sizes-add', classes.button)}>
                  <div
                    className={clsx('sizes-add__container', classes.addButton)}
                  >
                    <div
                      className={clsx(
                        'sizes-add__qtySelector',
                        classes.quantSelector
                      )}
                    >
                      <QuantitySelector
                        value={quantity !== 0 ? quantity : 1}
                        disable={code === ''}
                        handleChange={changeQuantity}
                        min={1}
                        max={maxItemsInCart}
                        loading={cart.loading}
                        variantSku={selectedVariant?.sku}
                      />
                    </div>
                    <MainTooltip
                      placement={'top'}
                      //PopperProps={{ disablePortal: true }}
                      open={showTooltipRent && code === ''}
                      title={prismicText(
                        text?.data?.choose_button_tooltip,
                        t('texts:single_product:choose_button_tooltip')
                      )}
                      arrow
                      enterDelay={2000}
                    >
                      <div
                        onMouseEnter={() => setShowTooltipRent(true)}
                        onMouseLeave={() => setShowTooltipRent(false)}
                        className={classes.fullWidth}
                      >
                        <Button
                          variant="contained"
                          color="secondary"
                          disabled={code === '' || cart.loading}
                          data-testid={'btn-addToCart'}
                          id="btn-addToCart"
                          className="sizes-add__btn"
                          onClick={() =>
                            onQuantityChange(
                              code,
                              name,
                              quantity !== 0 ? quantity : 1,
                              false
                            )
                          }
                        >
                          {variants[0].purchase ? (
                            <CMSText
                              asText
                              data={text?.data?.buy_button}
                              defaultText={t('texts:single_product:buy_button')}
                            />
                          ) : (
                            <CMSText
                              asText
                              data={text?.data?.choose_button}
                              defaultText={t(
                                'texts:single_product:choose_button'
                              )}
                            />
                          )}
                        </Button>
                      </div>
                    </MainTooltip>
                  </div>
                </div>
              ) : (
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={code === '' || cart.loading || hasInStock === 0}
                  data-testid={'btn-addToCart'}
                  id="btn-addToCart"
                  className="sizes-add__btn"
                  onClick={() =>
                    onQuantityChange(
                      code,
                      name,
                      quantity !== 0 ? quantity : 1,
                      false
                    )
                  }
                >
                  {variants[0].purchase ? (
                    <CMSText
                      asText
                      data={text?.data?.buy_button}
                      defaultText={t('texts:single_product:buy_button')}
                    />
                  ) : (
                    <CMSText
                      asText
                      data={text?.data?.choose_button}
                      defaultText={t('texts:single_product:choose_button')}
                    />
                  )}
                </Button>
              ))}
          </>
        ) : (
          code !== '' &&
          hasInStock !== 0 && (
            <ProductSkiForm
              skiText={skiText}
              product={products}
              variantCode={code}
            />
          )
        )}
        {hasTryOut && (
          <div className={clsx('tryout', classes.tryOut)}>
            <MainTooltip
              placement={'top'}
              //PopperProps={{ disablePortal: true }}
              open={showTooltipRent && code === ''}
              title={prismicText(
                text?.data?.choose_button_tooltip,
                t('texts:single_product:choose_button_tooltip')
              )}
              arrow
              enterDelay={2000}
            >
              <div
                onMouseEnter={() => setShowTooltipRent(true)}
                onMouseLeave={() => setShowTooltipRent(false)}
                className={classes.fullWidth}
              >
                <Button
                  fullWidth
                  variant="contained"
                  color="secondary"
                  disabled={
                    code === '' ||
                    maxItemsInCart === quantity ||
                    hasInStock === 0
                  }
                  onClick={() => {
                    onQuantityChange(code, name, quantity + 1, false)
                    setShowTooltipRent(false)
                  }}
                  data-testid={'btn-addToCart'}
                  id="btn-addToCart"
                >
                  <CMSText
                    asText
                    data={text?.data?.choose_button}
                    defaultText={t('texts:single_product:choose_button')}
                  />
                </Button>
              </div>
            </MainTooltip>
            <MainTooltip
              placement={'bottom'}
              //PopperProps={{ disablePortal: true }}
              open={
                showTooltip &&
                (code === '' ||
                  cart?.item?.items?.length === 0 ||
                  !isTryOutAble)
              }
              title={prismicText(
                text?.data?.try_out_tooltip,
                t('texts:single_product:try_out_tooltip')
              )}
              arrow
              enterDelay={2000}
            >
              <div
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                className={classes.fullWidth}
              >
                <Button
                  fullWidth
                  variant="outlined"
                  className={clsx('tryout__btn', classes.tryOutButton)}
                  //color="secondary"
                  disabled={
                    code === '' ||
                    cart?.item?.items?.length === 0 ||
                    !isTryOutAble ||
                    typeof cart.item.items.find(
                      (item) => item.product.variants[0].code === code
                    ) !== 'undefined' ||
                    hasInStock === 0
                  }
                  onClick={() => {
                    onQuantityChange(code, name, quantity + 1, true)
                    setShowTooltip(false)
                    trackEvent({
                      category: 'Products',
                      action: `User add ${name} for tryout`,
                    })
                  }}
                >
                  <CMSText
                    asText
                    data={text?.data?.try_out_button}
                    defaultText={t('texts:single_product:try_out_button')}
                  />
                  &nbsp;
                  <Price
                    amount={tryOnPrice}
                    showDayOrMonth={false}
                    dayOrMonth={settings?.data?.day_or_month}
                    dayOrMonthShort={settings?.data?.day_or_month_short}
                    displayFlexPrice={settings?.display_flex_price_a_day}
                  />
                </Button>
              </div>
            </MainTooltip>
          </div>
        )}
      </div>
    </>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Size)
